export enum ServerMsgType {
    NEW_CHANGES = 'NEW_CHANGES',
    USER_NEWINFO = 'USER_NEWINFO',
    USER_NEWINFOS = 'USER_NEWINFOS',
    USER_LEAVE = 'USER_LEAVE',
    CURSOR_MESSAGE = 'CURSOR_MESSAGE',
    CURSOR_MESSAGES = 'CURSOR_MESSAGES',
    RIGHT_MESSAGE = 'RIGHT_MESSAGE',
    TITLE_MESSAGE = 'TITLE_MESSAGE',
    HANDLE_DELETE = 'HANDLE_DELETE',
    COMM_NOTICE = 'COMM_NOTICE',
    CODEREV_NEW = 'CODEREV_NEW',
    LAST_REVERSION = 'LAST_REVERSION',
    REVERT_MESSAGE = 'REVERT_MESSAGE',
    ALL_LOCK_INFO = 'ALL_LOCK_INFO',
    UNLOCK_INFO = 'UNLOCK_INFO',
    LIVE_MESSAGE = 'LIVE_MESSAGE',
    COMMERCIALIZE_MESSAGE = 'COMMERCIALIZE_MESSAGE',
    MARK_MESSAGE = 'MARK_MESSAGE',
    PRESENT_INFO = 'PRESENT_INFO',
    // 私有化专属，上传新版本后会触发该事件
    COMMIT_UPLOAD = 'COMMIT_UPLOAD',
}
